import * as React from 'react';
import DeliveryMethodForm from "../../components/DeliveryMethods/DeliveryMethodForm/DeliveryMethodForm";
var DeliveryMethod = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u043C\u0435\u0442\u043E\u0434 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(DeliveryMethodForm, null))))));
};
export default DeliveryMethod;



//////////////////
// WEBPACK FOOTER
// ./src/views/DeliveryMethods/DeliveryMethod.tsx
// module id = 340
// module chunks = 0